/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/PipelinesAuthorizationSource" />
import * as Constants from "DistributedTaskUI/SecurityComponent/Constants";
import Authorization_Contracts = require("PipelineChecks/Authorization/Client/Contracts/PipelinePermissions");
import Authorization_Client = require("PipelineChecks/Authorization/Client/RestClient/PipelinePermissions");
import { IBuildRestClient } from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/RestClient/Build";
import { BuildDefinitionReference } from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/Contracts/Build";
import { IVssPageContext } from "VSS/Platform/Context";
import { getTFSPageData } from "Tfs/Platform/Page";

export class PipelinesAuthorizationSource {
    constructor(
        private _pageContext: IVssPageContext
    ) {
        this._authorizationClient = this._pageContext.getRestClient<Authorization_Client.IPipelinePermissionsRestClient>("dt.pipeline.authorization.client.IPipelinePermissionsRestClient");
        this._buildRestClient = this._pageContext.getRestClient<IBuildRestClient>("dt-security.build.client.IBuildRestClient");
        const tfsPageData = getTFSPageData(this._pageContext);
        if (tfsPageData && tfsPageData.project) {
            this._projectId = tfsPageData.project.id;
        }
    }

    public getPipelinePermissionsForResource(resourceType: string, resourceId: string): Promise<Authorization_Contracts.ResourcePipelinePermissions> {
        return this._authorizationClient.getPipelinePermissionsForResource(this._projectId, resourceType, resourceId);
    }

    public updatePipelinePermisionsForResource(resourceType: string, resourceId: string, authorizedDefinitions: Authorization_Contracts.ResourcePipelinePermissions): Promise<Authorization_Contracts.ResourcePipelinePermissions> {
        return this._authorizationClient.updatePipelinePermisionsForResource(authorizedDefinitions, this._projectId, resourceType, resourceId);
    }

    public getAllBuildDefinitions(): Promise<BuildDefinitionReference[]> {
        return this._buildRestClient.getDefinitions(this._projectId, null, null, null, null, null, null, null, null, null, null, null, null, null, null, Constants.YAMLProcessType);
    }

    public getAuthorizedBuildDefinitions(definitionIds: number[]): Promise<BuildDefinitionReference[]> {
        return this._buildRestClient.getDefinitions(this._projectId, null, null, null, null, null, null, null, definitionIds);
    }

    private _authorizationClient: Authorization_Client.IPipelinePermissionsRestClient;
    private _projectId: string;
    private _buildRestClient: IBuildRestClient;
}
